import { Component } from "react"

/* Components */
import { DataLayout, Pagination, Icon } from "../../components"

/* Widgets */
import { toast } from "../../widgets/common"

/* Shared */
import { ago, initialsOf, avatarColorOf } from "../../widgets/user/shared"
import { plural } from "../../widgets/category/shared"

/* REST API */
import { list, status, media } from "../../api/Inbox"

/* Moment */
import moment from "moment"


/* The states the list is cut by */
const FILTERS = [
    { key: "new", text: "Новые" },
    { key: "done", text: "Разобранные" },
    { key: "all", text: "Все" }
]

/* What the messages are made of */
const TYPES = [
    { key: "", text: "Любые" },
    { key: "text", text: "Текст" },
    { key: "files", text: "Файлы" }
]

/* Statuses of a booking in the words of the points */
const BOOKING_STATUSES = {
    0: { text: "ожидание", accent: "green" },
    1: { text: "подтверждена", accent: "violet" },
    2: { text: "завершена", accent: "blue" },
    3: { text: "отменена", accent: "red" },
    4: { text: "не пришёл", accent: "red" }
}

/* The empty filters */
const INITIAL = { search: "", status: "new", type: "", number: null }


/* Page Inbox — what clients write to the Whatsapp number of the platform: «спасибо», «опоздаю»,
   a photo of the receipt. The answer of the Flow of the reminder moves the booking by itself and
   is not here. Every message comes with the visit it is about, the same one the Telegram chats
   of the team hear about. A file stays in Meta and is opened on demand — Meta keeps it a month */
class Inbox extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            count: 0,
            limit: 30,
            page: 1,
            counters: null,
            waiting: null,
            files: {},
            ...INITIAL
        }

        this._timer = null
    }

    componentDidMount = () => {

        window.scrollTo(0, 0)
        this.load(1, true)
    }

    componentWillUnmount = () => {

        clearTimeout(this._timer)

        /* The files opened on the page are let go */
        Object.values(this.state.files).forEach(file => {
            if (file && file.url) {
                URL.revokeObjectURL(file.url)
            }
        })
    }

    load = (page = 1, reload = false) => {

        /* Fields */
        const { search, status: state, type, number } = this.state

        if (reload) {
            this.setState({ status: "loading" })
        }

        this.setState({ page })

        list({ page, search, status: state === "all" ? "" : state, type, waID: number ? number.waID : "" }).then(response => {
            if (response && response.status === 200) {
                this.setState({
                    status: "ok",
                    data: response.data.list,
                    count: response.data.total,
                    limit: response.data.limit,
                    counters: response.data.counters
                })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }

    refilter = fields => {
        this.setState(fields, () => this.load(1, true))
    }

    searchText = text => {

        clearTimeout(this._timer)
        this.setState({ search: text })

        this._timer = setTimeout(() => this.load(1, true), text.length === 0 ? 0 : 450)
    }

    /* Dealt with or back to the new ones — one message or the whole number */
    move = (event, item, next, whole = false) => {

        event.stopPropagation()

        if (this.state.waiting) {
            return
        }

        this.setState({ waiting: item.id })

        status(whole ? { waID: item.waID, status: next } : { ids: [item.id], status: next }).then(response => {

            this.setState({ waiting: null })

            if (response && response.status === 200) {
                toast.success(next === "done" ? (whole ? "Вся переписка разобрана" : "Отмечено разобранным") : "Вернули в новые")
                this.load(this.state.page)
            }
            else {
                toast.error("Что-то пошло не так! Попробуйте позднее")
            }
        }).catch(() => {
            this.setState({ waiting: null })
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    /* Open the file of a message — it is asked from Meta through the backend */
    open = item => {

        /* Fields */
        const { files } = this.state

        if (files[item.id]) {
            return
        }

        this.setState({ files: { ...files, [item.id]: { loading: true } } })

        media({ id: item.id }).then(response => {

            if (response && response.status === 200 && response.data) {

                const url = URL.createObjectURL(response.data)

                this.setState({ files: { ...this.state.files, [item.id]: { url, type: response.data.type } } })
                return
            }

            this.setState({ files: { ...this.state.files, [item.id]: { gone: true } } })
        }).catch(() => {
            this.setState({ files: { ...this.state.files, [item.id]: { gone: true } } })
        })
    }

    _header = () => {

        /* Fields */
        const { search } = this.state

        return (
            <div className="organization-header">

                <div className="page-header-text">WhatsApp</div>

                <div className="organization-header-tools">
                    <form onSubmit={event => { event.preventDefault(); clearTimeout(this._timer); this.load(1, true) }} className="organization-search service-search">
                        <div className="organization-search-icon">
                            <Icon name="search" size={17} />
                        </div>
                        <input placeholder="Имя, телефон, текст, точка или № записи" value={search} onChange={event => this.searchText(event.target.value)} />
                        {search.length > 0 &&
                            <div onClick={() => this.searchText("")} className="organization-search-clear">
                                <Icon name="close" size={11} width={2.4} />
                            </div>
                        }
                    </form>
                </div>

            </div>
        )
    }

    /* The inbox in numbers */
    _summary = () => {

        /* Fields */
        const { counters } = this.state

        if (!counters) {
            return null
        }

        return (
            <div className="inbox-summary">
                <div className="inbox-summary-main">
                    <div className="inbox-summary-icon"><Icon name="phone" size={22} width={2} /></div>
                    <div>
                        <b>{counters.fresh.toLocaleString("ru-RU")} {plural(counters.fresh, "новое сообщение", "новых сообщения", "новых сообщений")}</b>
                        <span>Всё, что клиенты пишут на номер BOOKIFY KZ. Каждое сообщение приходит и в Telegram команды</span>
                    </div>
                </div>
                <div className="inbox-summary-numbers">
                    <div><b>{counters.today}</b><span>сегодня</span></div>
                    <div><b>{counters.week}</b><span>за 7 дней</span></div>
                    <div><b>{counters.numbers}</b><span>{plural(counters.numbers, "номер", "номера", "номеров")}</span></div>
                </div>
            </div>
        )
    }

    _toolbar = () => {

        /* Fields */
        const { status: state, type, count, counters, number } = this.state

        return (
            <div className="service-toolbar">

                <div className="service-segment">
                    {FILTERS.map(item =>
                        <div key={item.key} onClick={() => this.refilter({ status: item.key })} className={state === item.key ? "active" : ""}>
                            {item.text}
                            {item.key === "new" && counters && counters.fresh > 0 && <span className="support-segment-count">{counters.fresh}</span>}
                        </div>
                    )}
                </div>

                <div className="service-segment">
                    {TYPES.map(item =>
                        <div key={item.key} onClick={() => this.refilter({ type: item.key })} className={type === item.key ? "active" : ""}>{item.text}</div>
                    )}
                </div>

                {number &&
                    <div className="service-filter active">
                        <Icon name="phone" size={15} width={2} />
                        {number.name ? `${number.name} · ` : ""}{number.phone}
                        <div onClick={() => this.refilter({ number: null })} className="service-filter-clear"><Icon name="close" size={9} width={2.6} /></div>
                    </div>
                }

                <div className="user-count">{count.toLocaleString("ru-RU")} {plural(count, "сообщение", "сообщения", "сообщений")}</div>

            </div>
        )
    }

    /* The file of a message — opened on demand */
    _file = item => {

        /* Fields */
        const file = this.state.files[item.id]

        if (!item.hasFile) {
            return null
        }

        if (!file) {
            return (
                <div onClick={event => { event.stopPropagation(); this.open(item) }} className="inbox-file-open">
                    <Icon name="image" size={14} width={2} />
                    {item.type === "image" || item.type === "sticker" ? "Показать фото" : "Открыть файл"}
                </div>
            )
        }

        if (file.loading) {
            return <div className="inbox-file-open disabled"><Icon name="refresh" size={14} width={2} />Загружаем из WhatsApp…</div>
        }

        if (file.gone) {
            return <div className="inbox-file-open disabled">Файл больше не доступен — Meta хранит файлы месяц</div>
        }

        if (`${file.type}`.startsWith("image/")) {
            return <a href={file.url} target="_blank" rel="noreferrer" onClick={event => event.stopPropagation()}><img className="inbox-file-image" src={file.url} alt="" /></a>
        }

        if (`${file.type}`.startsWith("video/")) {
            return <video className="inbox-file-video" src={file.url} controls onClick={event => event.stopPropagation()} />
        }

        if (`${file.type}`.startsWith("audio/")) {
            return <audio className="inbox-file-audio" src={file.url} controls onClick={event => event.stopPropagation()} />
        }

        return (
            <a href={file.url} download={item.fileName ? item.fileName : "file"} onClick={event => event.stopPropagation()} className="inbox-file-open">
                <Icon name="down" size={14} width={2} />
                Скачать{item.fileName ? ` «${item.fileName}»` : ""}
            </a>
        )
    }

    /* The visit the message is about */
    _booking = item => {

        if (!item.bookingID) {
            return <div className="inbox-booking empty">Записей с этого номера нет</div>
        }

        /* Fields */
        const state = BOOKING_STATUSES[parseInt(item.bookingStatus)] ? BOOKING_STATUSES[parseInt(item.bookingStatus)] : { text: "—", accent: "grey" }
        const coming = item.reservedTime && moment(item.reservedTime).isAfter(moment())

        return (
            <div className="inbox-booking">
                <span>{item.replyTo ? "Запись" : (coming ? "Ближайшая запись" : "Последняя запись")}</span>
                <b>№{item.bookingNumber ? item.bookingNumber : item.bookingID}</b>
                <span>{moment(item.reservedTime).format("D MMMM, HH:mm")}</span>
                <div className={`user-badge ${state.accent}`}>{state.text}</div>
                <span>·</span>
                <b>{item.organization ? item.organization : "—"}</b>
                {item.organizationPhone && <span>{item.organizationPhone}</span>}
                {item.master && <span>· {item.master}</span>}
            </div>
        )
    }

    /* One message */
    _item = item => {

        /* Fields */
        const { waiting, number } = this.state

        const name = item.name && `${item.name}`.trim().length > 0 ? `${item.name}`.trim() : (item.bookingUser ? item.bookingUser : null)

        return (
            <div key={`${item.id}`} className={`support-item inbox-item ${item.status === "done" ? "done" : "new"}`}>

                <div className="support-item-avatar-wrap" style={{ "--avatar": avatarColorOf(parseInt(`${item.waID}`.slice(-6)) || item.id) }}>
                    <div className="support-avatar inbox-avatar">
                        {name ? <span>{initialsOf(name)}</span> : <Icon name="user" size={18} width={2} />}
                    </div>
                </div>

                <div className="support-item-body">

                    <div className="support-item-head">
                        <b className={name ? "" : "empty"}>{name ? name : "Без имени"}</b>
                        <a href={`https://wa.me/${item.waID}`} target="_blank" rel="noreferrer" className="inbox-phone" title="Написать в WhatsApp">{item.phone}</a>
                        {!number && item.fromNumber > 1 &&
                            <div onClick={() => this.refilter({ number: { waID: item.waID, phone: item.phone, name }, status: "all" })} className="inbox-thread" title="Вся переписка с номером">
                                {item.fromNumber} {plural(item.fromNumber, "сообщение", "сообщения", "сообщений")}
                            </div>
                        }
                    </div>

                    {item.replyToText && <div className="inbox-reply"><Icon name="left" size={11} width={2.4} />Ответ на «{item.replyToText}»</div>}

                    {item.label && <div className="inbox-label">{item.label}{item.fileName ? ` «${item.fileName}»` : ""}</div>}

                    {item.text && <div className="support-item-text inbox-text">{item.text}</div>}

                    {this._file(item)}

                    {this._booking(item)}

                </div>

                <div className="support-item-side">

                    <span title={new Date(item.receivedAt).toLocaleString("ru-RU")}>{ago(item.receivedAt)}</span>

                    {item.status === "done"
                        ? <div className="user-badge grey" title={item.resolvedByName ? `Разобрал: ${item.resolvedByName}` : ""}><Icon name="check" size={11} width={2.4} />Разобрано</div>
                        : <div className="user-badge green"><i />Новое</div>
                    }

                    <div className="support-item-actions">
                        {item.status === "new"
                            ? <>
                                <div onClick={event => this.move(event, item, "done")} className="done" title="Отметить разобранным">
                                    {waiting === item.id ? <Icon name="refresh" size={14} width={2.2} /> : <Icon name="check" size={14} width={2.6} />}
                                </div>
                                {item.fromNumber > 1 &&
                                    <div onClick={event => this.move(event, item, "done", true)} title="Разобрать всю переписку с номером"><Icon name="layers" size={14} width={2.2} /></div>
                                }
                            </>
                            : <div onClick={event => this.move(event, item, "new")} title="Вернуть в новые"><Icon name="refresh" size={14} width={2.2} /></div>
                        }
                    </div>

                </div>

            </div>
        )
    }

    _content = () => {

        /* Fields */
        const { status: state, data, count, page, limit } = this.state

        if (state !== "ok" || data.length === 0) {
            return (
                <div className="page-content">
                    {this._summary()}
                    {this._toolbar()}
                    <DataLayout status={state} reload={() => this.load(1, true)} data={data} onReset={() => this.refilter({ ...INITIAL })} />
                </div>
            )
        }

        return (
            <div className="page-content">

                {this._summary()}
                {this._toolbar()}

                <div className="support-list">
                    {data.map(item => this._item(item))}
                </div>

                <Pagination size={limit} page={page} total={count} onPageChange={page => { window.scrollTo(0, 0); this.load(page, true) }} />

            </div>
        )
    }

    render = () => {
        return (
            <div className="page">
                {this._header()}
                {this._content()}
            </div>
        )
    }
}

export default Inbox
